import { useState } from 'react';
import * as themes from '../theme/schema.json'
import _ from 'lodash';


export default function useTheme(themeName = "default") {
    const [theme, setTheme] = useState(themes.data[themeName]);

    const getFonts = () => {
        const allFonts = _.pickBy(themes.data, function(value, key){
            return !value.locale;
        });
        return _.values(_.mapValues(allFonts, 'font'))
    }

    const getFontsLocale = () =>{
        const allF = _.pickBy(themes.data, function(value, key){
            return value.locale;
        });
        return _.values(_.mapValues(allF, 'font'))
    } 

    return { theme, setTheme, getFonts, getFontsLocale };
}
